import { useLocation } from "react-router-dom";

const routeMeta = {
    "/": {
        title: "Bccexx - Financial Education & Quiz Platform | Learn Finance Through Interactive Games",
        description: "Master personal finance, investing, and money management through engaging quizzes and educational content. Win rewards while learning essential financial skills on Bccexx.",
    },
    "/coins": {
        title: "Coin History - Bccexx",
        description: "Track your coin earnings and spending history on Bccexx financial education platform.",
    },
    "/search": {
        title: "Search Quizzes - Bccexx",
        description: "Search and discover financial education quizzes on Bccexx. Find topics on investing, budgeting, and money management.",
    },
    "/contest-rules": {
        title: "Contest Rules - Bccexx",
        description: "Read the official contest rules and guidelines for Bccexx financial education quiz competitions.",
    },
    "/quiz/bonus": {
        title: "Bonus Quiz - Bccexx",
        description: "Play the bonus quiz and earn free coins on Bccexx financial education platform.",
    },
    "/quiz/bonus/result": {
        title: "Quiz Results - Bccexx",
        description: "View your bonus quiz results and coin rewards on Bccexx.",
    },
    "/quiz/result": {
        title: "Quiz Result - Bccexx",
        description: "View your quiz performance and results on Bccexx financial education platform.",
    },
    "/profile": {
        title: "My Profile - Bccexx",
        description: "Manage your Bccexx profile, view your quiz history, and track your financial education progress.",
    },
    "/maintenance": {
        title: "Under Maintenance - Bccexx",
        description: "Bccexx is currently under maintenance. We will be back shortly.",
    },
};

const defaultMeta = {
    title: "Bccexx - Financial Education & Quiz Platform",
    description: "Master personal finance through interactive quizzes and educational content. Win rewards while learning essential financial skills on Bccexx.",
};

const SEO = () => {
    const { pathname } = useLocation();

    const basePath = pathname.replace(/\/[^/]+$/, "") ;
    const meta = routeMeta[pathname] || routeMeta[basePath] || defaultMeta;

    const canonicalUrl = `https://www.bccexx.com${pathname === "/" ? "" : pathname}`;

    return (
        <>
            <title>{meta.title}</title>
            <meta name="description" content={meta.description} />
            <link rel="canonical" href={canonicalUrl} />
            <meta property="og:title" content={meta.title} />
            <meta property="og:description" content={meta.description} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="twitter:title" content={meta.title} />
            <meta property="twitter:description" content={meta.description} />
            <meta property="twitter:url" content={canonicalUrl} />
        </>
    );
};

export default SEO;
